import { dictionaries, DEFAULT_LANG } from './index';
import { formatDisplayCount } from './formatCount';

function lookup(dictionary: unknown, key: string): string | undefined {
  let value = dictionary;
  for (const part of key.split('.')) {
    if (!value || typeof value !== 'object'
      || !Object.prototype.hasOwnProperty.call(value, part)) return undefined;
    value = (value as Record<string, unknown>)[part];
  }
  return typeof value === 'string' ? value : undefined;
}

export function translate(
  language: string,
  key: string,
  params?: Record<string, string | number>,
): string {
  const localTemplate = lookup(dictionaries[language], key);
  const template = localTemplate
    ?? lookup(dictionaries[DEFAULT_LANG], key)
    ?? key;
  if (!params) return template;

  // Insert names/amounts literally and once. Replacement tokens ($&, $') and
  // placeholder-looking user content must never rewrite the surrounding copy.
  return template.replace(/\{([^{}]+)\}/g, (placeholder, name: string) => {
    if (!Object.prototype.hasOwnProperty.call(params, name)) return placeholder;
    const value = params[name];
    // Only numeric count/time-quantity slots are localized. Names, phone/OTP,
    // preformatted amounts, user strings and fallback copy remain literal.
    if (localTemplate !== undefined && (name === 'count' || name === 'n') && typeof value === 'number') {
      return formatDisplayCount(value, language);
    }
    return String(value);
  });
}
